export { default } from './AddButton';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/AddButton/index.js